import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissionRequestDialogComponent } from '@/app/shared/components/permission-request-dialog.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, PermissionRequestDialogComponent],
    template: `
        <router-outlet></router-outlet>
        <app-permission-request-dialog />
    `
})
export class AppComponent {}
